/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForGcpInherited extends models.ServiceAccountCredentialsBaseForGcp {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForGcpInherited");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForGcpInherited.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForGcpInherited>): ServiceAccountCredentialsForGcpInherited {
        let obj = Object.assign(new ServiceAccountCredentialsForGcpInherited(), model);
        ServiceAccountCredentialsForGcpInherited.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForGcpInherited>): ServiceAccountCredentialsForGcpInherited {
        if (!model) return null;
        return ServiceAccountCredentialsForGcpInherited.newInstance(<ServiceAccountCredentialsForGcpInherited> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForGcpInherited) {
        if (!obj) return;

        models.ServiceAccountCredentialsForGcpInherited.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForGcpInherited): boolean {
        if (models.ServiceAccountCredentialsBaseForGcp.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForGcpInherited.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
